<template>
    <BModal v-model="isOpen" size="md" centered hide-footer title="Sub location">
        <div v-if="subLocation">
            <AppInput :value="subLocation.location"
                      @input="updateSubLocationProp({ location: $event })"
                      label="Sub location name"
                      field="location"/>
            <div class="row mt-3">
                <div class="col-12 d-flex justify-content-between">
                    <button class="btn btn-outline-danger mr-2"
                            @click="destroy"
                            v-if="!isNewSubLocation">
                        Delete
                    </button>
                    <button class="btn btn-primary"
                            @click="saveAndClose"
                            :disabled="!subLocation.location">
                        Save & close
                    </button>
                </div>
            </div>
        </div>
    </BModal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { BModal } from 'bootstrap-vue';
import NotificationService from '../../services/notification.service';
import AppInput from '../form/AppInput';

export default {
  props: ['locationModal'],
  components: {
    AppInput,
    BModal,
  },
  computed: {
    ...mapGetters({
      subLocation: 'subLocations/subLocation',
    }),
    ...mapState({
      isNewSubLocation: (state) => state.subLocations.isNewSubLocation,
    }),
    isOpen: {
      get() {
        return this.$store.state.subLocations.isModalOpen;
      },
      set(val) {
        this.$store.dispatch('subLocations/clearCurrentSubLocation');
        this.$store.commit('subLocations/isModalOpen', val);
      },
    },
  },
  methods: {
    destroy() {
      this.$store.dispatch('subLocations/deleteSubLocation')
        .then((res) => {
          NotificationService.success(res.message);
        });
      this.$store.commit('subLocations/isModalOpen', false);
    },
    saveAndClose() {
      this.$store.dispatch(this.isNewSubLocation ? 'subLocations/createSubLocation' : 'subLocations/updateSubLocation')
        .then((res) => {
          if (this.locationModal.isOpen) {
            this.$store.dispatch('locations/newLocationAdded', this.subLocation);
          }
          NotificationService.success(res.message);
        })
        .finally(() => {
          this.$store.commit('subLocations/isModalOpen', false);
        });
    },
    updateSubLocationProp(props) {
      this.$store.dispatch('subLocations/updateSubLocationProps', props);
    },
  },
};
</script>
